import { Box, Modal, IconButton, useMediaQuery, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export function BasicModal(props) {
	const {
		width,
		showModal,
		handleClose,
		hideClose,
		children,
		noPadding,
		contentSx,
	} = props;
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	const close = () => {
		handleClose();
	};

	return (
		<Modal
			open={showModal}
			onClose={close}
			disableAutoFocus={true}
			slotProps={{
				root: {
					sx: {
						zIndex: 10002, // Por encima de la tab bar (10001) y el overlay (9998)
					},
				},
				backdrop: {
					sx: {
						zIndex: 10001, // Por encima del overlay (9998) pero debajo del contenido de la modal
					},
				},
			}}
		>
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					...(isMobile ? { py: 1.5, px: 1.5 } : { p: 4 }),
					height: "100%",
					zIndex: 10002,
					position: "relative",
					boxSizing: "border-box",
				}}
			>
				<Box
					sx={{
						position: "relative",
						width: "100%",
						maxWidth: isMobile ? "100%" : width,
						bgcolor: "#fff",
						...(noPadding
							? { p: 0 }
							: isMobile
								? { pt: 3, px: 2, pb: 3 }
								: { p: 4 }),
						maxHeight: isMobile
							? "calc(100dvh - 24px)"
							: "calc(100vh - 64px)",
						overflow: "auto",
						borderRadius: isMobile ? 3 : 2,
						zIndex: 10002,
						...contentSx,
					}}
				>
					{children}
					{!hideClose && (
						<IconButton
							aria-label="close"
							onClick={handleClose}
							sx={{
								position: "absolute",
								right: isMobile ? 4 : 8,
								top: isMobile ? 4 : 8,
								color: contentSx
									? "#64748b"
									: (theme) => theme.palette.grey[500],
								zIndex: 1,
								"&:hover": contentSx
									? { color: "#1e293b", bgcolor: "#f1f5f9" }
									: {},
							}}
						>
							<CloseIcon />
						</IconButton>
					)}
				</Box>
			</Box>
		</Modal>
	);
}
